var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"all-center"},[_c('b-col',{attrs:{"cols":"12","sm":"8","md":"8","lg":"6","xl":"4"}},[_c('form-password-reset')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }